import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { extract } from '@app/core';
import { GamesWrapperComponent } from '@app/_v2/games/games.component';
import { GameCanvasComponent } from '@app/_v2/games/game-canvas/game-canvas.component';
import { VipMemberGuard } from '@app/core/vip-member.guard';

const routes: Routes = [
  {
    path: '',
    component: GamesWrapperComponent,
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: 'under-the-aegis',
        loadChildren: 'app/_v2/games/under-the-aegis/under-the-aegis.module#UnderTheAegisModule',
        data: { title: extract('Edgeless - Under the aegis'), allowChat: false },
      },
      {
        path: '',
        component: GameCanvasComponent,
        children: [
          {
            path: 'treasure-hunt',
            loadChildren: 'app/_v2/games/treasure/treasure.module#TreasureModule',
            data: { title: extract('Edgeless - Treasure hunt'), allowChat: true, subHeader: true },
          },
          {
            path: 'roulette',
            loadChildren: 'app/_v2/games/roulette/roulette.module#RouletteModule',
            data: { title: extract('Edgeless - Roulette'), allowChat: true, subHeader: true },
          },
          {
            path: 'video-poker',
            loadChildren: 'app/_v2/games/video-poker/video-poker.module#VideoPokerModule',
            data: { title: extract('Edgeless - Video poker'), allowChat: true, subHeader: true },
          },
          {
            path: 'dice',
            loadChildren: 'app/_v2/games/dice/dice.module#DiceModuleV2',
            data: { title: extract('Edgeless - Dice'), allowChat: true, subHeader: true },
          },
          // {
          //   path: 'spooky-dice',
          //   loadChildren: 'app/_v2/games/spooky-dice/spooky-dice.module#SpookyDiceModuleV2',
          //   data: { title: extract('Edgeless - Spooky dice'), allowChat: true, subHeader: true },
          // },
          // {
          //   path: 'ice-dice',
          //   loadChildren: 'app/_v2/games/ice-dice/ice-dice.module#IceDiceModuleV2',
          //   data: { title: extract('Edgeless - Ice dice'), allowChat: true, subHeader: true },
          // },
          {
            path: 'slots',
            loadChildren: 'app/_v2/games/slots/slots.module#SlotsModuleV2',
            // canLoad: [VipMemberGuard],
            data: { title: extract('Edgeless - Slots'), allowChat: true, subHeader: true },
          },
          // {
          //   path: 'baccarat',
          //   loadChildren: 'app/_v2/games/baccarat/baccarat.module#BaccaratModule',
          //   data: { title: extract('Edgeless - Baccarat'), allowChat: true, subHeader: true },
          // },
          {
            path: 'blackjack',
            loadChildren: 'app/_v2/games/blackjack/blackjack.module#BlackjackModule',
            data: { title: extract('Edgeless - BlackJack'), allowChat: true, subHeader: true },
          },
          {
            path: 'crash',
            loadChildren: 'app/_v2/games/crash/crash.module#CrashModuleV2',
            data: { title: extract('Edgeless - Crash'), allowChat: true, subHeader: true },
          },
          {
            path: 'crypto-gems',
            loadChildren: 'app/_v2/games/crypto-gems/crypto-gems.module#CryptoGemsModule',
            data: { title: extract('Edgeless - Crypto gems'), allowChat: true, subHeader: true },
          },
          // {
          //   path: 'hi-lo',
          //   loadChildren: 'app/_v2/games/hi-lo/hi-lo.module#HiLoModule',
          //   data: { title: extract('Edgeless - Hi-lo'), allowChat: true, subHeader: true },
          // },
          // {
          //   path: 'casino-war',
          //   loadChildren: 'app/_v2/games/casino-war/casino-war.module#CasinoWarModule',
          //   data: { title: extract('Edgeless - Casino war'), allowChat: false },
          // },
        ],
      },
    ],
  },
  /*{
    path: 'crash',
    loadChildren: 'app/_v2/games/crash/crash.module#CrashModuleV2',
    data: { title: extract('Edgeless - Crash'), allowChat: true },
  },*/
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class GamesRoutingModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/games-routing.module.ts